"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSION_TEXT = void 0;
var PERMISSION_TEXT = exports.PERMISSION_TEXT = {
  SHOW_CALLER: 'Show Caller permission is required'
};